export enum CompanyCreditBalance {
  programmeId = 'programmeId',
  programmeName = 'programmeName',
  sector = 'sector',
  quantity = 'quantity',
  isProgrammeOwner = 'isProgrammeOwner',
}
